<template>
  <transition class="modal modal-template" name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <h3>{{headerText}}</h3>
            <h5 v-if="subheaderText" class="sub-header">{{subheaderText}}</h5>
          </div>

          <div class="modal-body">
            <slot name="body">
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="modal-default-button" @click="$emit('close')">
                OK
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    headerText: String,
    subheaderText: String,
  },
};
</script>

<style scoped lang="scss">
@import '../assets/css/variables.scss';


.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  margin: 0px 8px;
  padding-top: 20px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  @media screen and (min-width: $break-sm) {
    max-width: 400px;
    margin: 0px auto;
  }
}

.modal-header, .modal-body {
  padding: 0px 30px;
}

.modal-header h3 {
  margin-top: 0;
  font-size: 25px;
  letter-spacing: 1px;
  font-weight: normal;
}

.modal-body {
  margin: 20px 10px;
  padding: 0px 20px;
  max-height: 350px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0.5em;
    border-radius: 10px;
    background-color: #c6c6c6;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #c6c6c6;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #868686;
    outline: 1px solid #868686;
  }
}

.modal-footer {
  margin: 0 30px;
}
.modal-footer button {
  display: inline-block;
  max-width: 300px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.cancel-button {
  background: none;
}

.sub-header {
  color:rgba(0, 0, 0, .33);
  font-size: 0.8rem;
}
</style>
